var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYellowBoatHat = function SvgYellowBoatHat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 43,
    viewBox: "0 0 65 43",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3282 28.2698L0 19.9523L21.9491 19.2591L17.3282 28.2698Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3282 28.2698L0 19.9523L21.9491 19.2591L17.3282 28.2698Z",
    fill: "url(#boat_hat_paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6741 28.0388L42.2808 19.0282L64.6919 18.104L49.6741 28.0388Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6741 28.0388L42.2808 19.0282L64.6919 18.104L49.6741 28.0388Z",
    fill: "url(#boat_hat_paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3146 35.8035L32.4042 0.452423L52.4382 29.0649L36.2655 38.1667L32.3146 35.8035Z",
    fill: "url(#boat_hat_paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4163 0.144135L9.08734 27.2344L32.4163 35.2073V0.144135Z",
    fill: "url(#boat_hat_paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1151 0.368958L8.78619 27.4592L32.1151 35.4322V0.368958Z",
    fill: "url(#boat_hat_paint4_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62973 39.0554L0.308044 20.3217L30.571 24.656L65 18.4734L58.1494 37.347L31.7913 42.7162L7.62973 39.0554Z",
    fill: "url(#boat_hat_paint5_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32169 38.747L0 20.0134L30.263 24.3477L64.692 18.165L57.8413 37.0386L31.4833 42.4079L7.32169 38.747Z",
    fill: "url(#boat_hat_paint6_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32169 38.747L0 20.0134L30.263 24.3477L64.692 18.165L57.8413 37.0386L31.4833 42.4079L7.32169 38.747Z",
    fill: "url(#boat_hat_paint7_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint0_linear",
    x1: 10.9745,
    y1: 19.2591,
    x2: 10.9745,
    y2: 28.2698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint1_linear",
    x1: 53.4863,
    y1: 18.104,
    x2: 53.4863,
    y2: 28.0388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint2_linear",
    x1: 54.2988,
    y1: -21.9817,
    x2: 38.2955,
    y2: 69.3572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FDC73C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint3_linear",
    x1: 27.4932,
    y1: -10.0215,
    x2: 27.9553,
    y2: 63.9871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint4_linear",
    x1: 32.1911,
    y1: 20.8605,
    x2: 2.07938,
    y2: -10.2524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint5_linear",
    x1: 32.6531,
    y1: 10.2171,
    x2: 0.396349,
    y2: 84.4359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint6_linear",
    x1: 31.883,
    y1: 30.0249,
    x2: 32.3451,
    y2: 59.5815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDC73C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_paint7_linear",
    x1: -39.6612,
    y1: 27.7915,
    x2: 91.5673,
    y2: 27.6375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856273,
    stopColor: "#FDC73C"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYellowBoatHat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yellow_boat_hat.9fcb608c.svg";
export { ForwardRef as ReactComponent };